export default "__VITE_ASSET__CMag4MoU__"